import { Component, inject } from '@angular/core';
import { CommunitySidenavComponent } from '../../community/community-sidenav/community-sidenav.component';
import { spaceAvatar } from '../community-format';
import { CommunityLayoutService } from '../community-layout.service';

/**
 * v2 spaces sidebar. All data, search, group filter, unread counts and
 * navigation come from CommunitySidenavComponent; only the template changes.
 */
@Component({
  selector: 'app-cm-sidenav',
  templateUrl: './cm-sidenav.component.html',
  styleUrls: ['./cm-sidenav.component.scss'],
})
export class CmSidenavComponent extends CommunitySidenavComponent {
  private readonly layout = inject(CommunityLayoutService);

  sectionLabel(section: string): string {
    const s = section === 'joined' || section === 'trending' ? section[0].toUpperCase() + section.slice(1) : section;
    return s === 'Channels' ? 'Spaces' : s;
  }

  isActive(channel: any): boolean {
    return (channel?.channelId || channel?.name) === this.activeChannel;
  }

  avatarFor(channel: any): string | null {
    return spaceAvatar(channel, this.groupsList);
  }

  visibleChannels(section: string): any[] {
    let list = this.getSectionChannels(section) || [];
    // Each space appears once: Starred first, then Joined, then Trending for everything else
    const urls = (s: string) => new Set((this.getSectionChannels(s) || []).map(c => c?.channelUrl).filter(Boolean));
    if (section === 'joined') {
      const starred = urls('Starred');
      list = list.filter(c => !starred.has(c?.channelUrl));
    } else if (section === 'trending') {
      const own = new Set([...urls('joined'), ...urls('Starred')]);
      list = list.filter(c => !own.has(c?.channelUrl));
    }
    const limited = section === 'trending' && !this.searchQuery ? list.slice(0, 5) : list;
    return limited.filter(c => this.matchesTab(c) && this.matchesSearch(c));
  }

  open(channel: any, privateTab = false): void {
    if (!privateTab && channel?.dataStatus !== 'A') return;
    this.navigateToCommunity(channel.channelId || channel.name, channel);
    this.layout.setRailOpen(false);
  }

  trackChannel(_: number, c: any): string {
    return c?.channelId || c?.name;
  }
}
